import React from 'react';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';

const NotificacoesTable = ({
  data,
  columns,
  loading,
  totalRegistros,
  paginationState,
  setPaginationState,
  onRowClick
}) => {
  return <TanStackTable data={Array.isArray(data) ? data : []} columns={columns} loading={loading} onRowClick={onRowClick} isSortable={true} withPagination={true} pageSizeOptions={[5, 10, 25, 50, 100]} manualPagination={true} totalItems={totalRegistros} onPaginationChange={setPaginationState} controlledPagination={{
    pageIndex: paginationState.pageIndex,
    pageSize: paginationState.pageSize
  }} enableColumnFilters={false} enableRowSelection={false} enableColumnResizing={true} enableGlobalFilter={false} />;
};

export default NotificacoesTable;